module.exports = __webpack_public_path__ + "img/dispositivo-small.601b5244.jpg";